import React, {useEffect, useState} from "react";
import ReportFiltersSection from '../components/sections/reportFilters';
import { useDispatch, useSelector } from "react-redux";
import { changeDimension, changeFilter, changePublisherView, createReport, changeIsDeal } from '../stateManagement/actions/report';
import { useAuth } from "../hooks/useAuth";
import { ADMIN_ACCESS, PARTITION_MAIN, PARTITION_THD } from "../utils/constants";
import ReportsTable from "../components/sections/reportsTable";
import { Button } from "antd";
import ActionTypes from "../stateManagement/actions/types";
import { useLocation } from "react-router-dom";

const ReportsPage = () => {
    
    //Prepare dispatcher
    const dispatch = useDispatch();

    //API data prep
    const [fullReport, setFullReport] = useState(null);

    //Loading table
    const [loadingTable, setLoadingTable] = useState(false);

    //Get required data from global state
    const {user} = useAuth();
    const reportData = useSelector((state) => state.reportReducer);
    const {period, filterBy, r_dimension_1, r_dimension_2, r_dimension_3, publisherView, splitByDay, isDeal} = reportData;
    const location = useLocation();
    const PARTITION = location.pathname.includes(PARTITION_THD) ? PARTITION_THD : PARTITION_MAIN;

    //Initial filters reset
    useEffect(()=>{
        dispatch(changeFilter(''));
        dispatch(changeDimension('', ActionTypes.R_CHANGE_DIMENSION_1));
        dispatch(changeDimension('', ActionTypes.R_CHANGE_DIMENSION_2));
        dispatch(changeDimension('', ActionTypes.R_CHANGE_DIMENSION_3));
        dispatch(changeIsDeal(false, ActionTypes.SWITCH_IS_DEAL));
    }, [dispatch]);

    //Load view mode
    useEffect(()=>{
        if(user && user.access && !publisherView){
            const accessList = user.access.split('+');
            dispatch(changePublisherView(accessList[0] === ADMIN_ACCESS ? 'Gemius' : accessList[0]));
        }
    }, [dispatch, user, publisherView])

    //Generate report
    const generateReport = () => {
        dispatch(
            createReport(
                {period, dimension_1: r_dimension_1, dimension_2: r_dimension_2, dimension_3: r_dimension_3, filterBy, publisherView, splitByDay, isDeal, partition: PARTITION}, 
                setFullReport, 
            )
        );
        setLoadingTable(true);
    }    
    
    useEffect(()=>{
        if(Array.isArray([fullReport])){
            setLoadingTable(false);
        }
    }, [fullReport])

    const resetReport = () => setFullReport(null)

    return (
        <>
            <h2>{`Reports for ${publisherView} account`}</h2>
            <div className="main-section">
                <div className="side-panel">
                     <ReportFiltersSection/>
                    {!fullReport && (<>
                        <Button onClick={generateReport} color="cyan" variant="solid" style={{margin: "30px auto"}}>Generate</Button>
                    </>)}
                    {fullReport && !loadingTable && (<>
                        <div className="side-panel-disabled-layer"></div>
                        <Button onClick={resetReport} color="danger" variant="solid" style={{margin: "30px auto 0px auto"}}>New report</Button>
                    </>)}
                </div>
                <div className="main-content">
                    {loadingTable && <h3 className="info-placeholder">Please, wait for the report to be generated...</h3>}
                    {fullReport?.length === 0 && !loadingTable && <h3 className="info-placeholder">No data to be displayed. Please, select the required inputs and click on 'Generate' button</h3>}
                    {fullReport?.length > 0 && !loadingTable && (<>
                        <ReportsTable fullData={fullReport}/>
                    </>)}
                </div>
            </div>
        </>
    );
}

export default ReportsPage;